<template>
  <div ref="TooltipGeneral" class="tooltip">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'TooltipGeneral',
  props: {
    title: {
      type: [Number, String],
      required: true
    },
    pointerEvent: {
      type: Object,
      default: null
    }
  },
  watch: {
    pointerEvent(event) {
      const tooltip = this.$refs.TooltipGeneral
      tooltip.style.left = event.clientX + 15 + 'px'
      tooltip.style.top = event.clientY - 15 + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/variables.scss';

.tooltip {
  background-color: variables.$color-grey-blue-darker;
  border-radius: variables.$border-radius-medium;
  color: variables.$color-text-white;
  display: block;
  font-family: variables.$font-family-secondary;
  font-size: variables.$font-size-general-paragraph;
  justify-content: center;
  text-align: center;
  opacity: 0.85;
  padding: variables.$padding-minor variables.$margin-information-display;
  position: fixed;
  z-index: 100;
}
</style>
